export default "__VITE_ASSET__DpO2WFjx__"